import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9670fc3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-token-checker"
}
const _hoisted_2 = {
  key: 0,
  id: "tokenAddress",
  type: "text",
  maxlength: "256",
  required: ""
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "tokenId",
  type: "text",
  maxlength: "256",
  required: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "submitTokenCheckButton",
  type: "submit",
  value: "Submit"
}, null, -1))
const _hoisted_5 = { class: "m-token-checker-results" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "This token has been used for this campaign.", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("template", null, [
          _createElementVNode("form", {
            class: "m-token-checker-form",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkToken && _ctx.checkToken(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("label", null, "Enter " + _toDisplayString(_ctx.checkerTokenAddress ? 'token ' : 'token address and ') + " id to check", 1),
              (!_ctx.checkerTokenAddress)
                ? (_openBlock(), _createElementBlock("input", _hoisted_2))
                : _createCommentVNode("", true),
              _hoisted_3
            ]),
            _hoisted_4
          ], 32),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.tokenHasBeenUsed === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : (_ctx.tokenHasBeenUsed === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " This token has not yet been used for this campaign. "))
                : (_ctx.tokenHasBeenUsed === -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Bad Input. Please check the contract address again and the tokenId is a number. "))
                  : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}